/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation FallbackRoutePlanDeleteManyMutation($routePlanIds: [ID!] !) {
    FallbackRoutePlanDeleteMany(routePlanIds: $routePlanIds){
      message
      status
    }
  }
`

